import { IconButton, Outside, Popover, UIText2, IconMore16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatMenu.css';

type TProps = {
  isOpen: boolean;
  isArchiveAvailable?: boolean;
  isBlockAvailable?: boolean;
  toggleMenu: (isOpen: boolean) => void;
  onSpamClick: () => void;
  onArchiveClick: () => void;
};

export const ChatMenu: React.FC<TProps> = ({
  isOpen,
  isArchiveAvailable,
  isBlockAvailable,
  toggleMenu,
  onSpamClick,
  onArchiveClick,
}) => {
  const contentRef = React.useRef<HTMLDivElement>(null);

  return (
    <Popover
      placement="bottom-end"
      open={isOpen}
      content={
        <Outside onOutside={() => toggleMenu(false)} active insideRefs={[contentRef]}>
          <div ref={contentRef} className={styles['container']} data-name="ChatMenu_list">
            {isArchiveAvailable && (
              <li className={styles['menu_item']} onClick={onArchiveClick}>
                <UIText2>Перенести в архив</UIText2>
              </li>
            )}
            {isBlockAvailable && (
              <li className={styles['menu_item']} onClick={onSpamClick}>
                <UIText2>Заблокировать чат</UIText2>
              </li>
            )}
          </div>
        </Outside>
      }
    >
      <IconButton
        icon={<IconMore16 color="gray60_100" />}
        onClick={() => toggleMenu(true)}
        data-name="ChatMenu_button"
      />
    </Popover>
  );
};
